export const PRICE_PER_MONTH: number = 24.50;
export const PRICE_PER_MONTH_WITH_DISCOUNT: number = 19.97;
export const ANNUALLY = 'annually';
export const MONTHLY = 'monthly';
